export default {
  bind(el, binding) {
    let isUpdating = false; // Флаг для предотвращения рекурсии

    const formatNumberValue = (inputValue) => {
      if (!inputValue) return inputValue;

      let value = inputValue.replace(/[^\d.,]/g, '');
      value = value.replace(/,/g, '.');
      const parts = value.split('.');

      value = parts.length > 2 ? `${parts[0]}.${parts.slice(1).join('')}` : value;
      if (value.startsWith('.')) value = `0.${value}`;

      return value;
    };

    const formatTextValue = (inputValue) => {
      if (!inputValue) return inputValue;

      const value = inputValue.replace(/./g, '');

      return value;
    };

    const handleEvent = (e) => {
      if (isUpdating) return;
      let value;

      if (binding.value === 'text') {
        value = formatTextValue(e.target.value);
      }

      if (binding.value === 'number') {
        value = formatNumberValue(e.target.value);
      }

      isUpdating = true;
      e.target.value = value;

      e.target.dispatchEvent(new Event('input', { bubbles: true }));
      isUpdating = false;
    };

    // Добавляем обработчики событий
    el.addEventListener('input', handleEvent);
    el.addEventListener('blur', handleEvent);
    el.addEventListener('focus', handleEvent);
  },
};
